import { AxiosResponse } from 'axios';

import { User } from '../pages/tech-support/Home.type';
import { axiosInstance } from './axios.config';
import { ResponseREST } from './response.type';

export const postUsers = async (body: User): Promise<ResponseREST> => {
	return axiosInstance
		.post('add-user-outlet', body)
		.then((res: AxiosResponse<ResponseREST>) => res.data)
		.catch((err) => err);
};
